import React, { FC } from 'react';
import classNames from 'classnames';
import { SearchBar } from '../../search/components/search-bar/SearchBar';
import { UserContextType } from '../../user/user.types';
import { withUser } from '../../user/UserContext';
import { HeaderContent } from '../HeaderContent';
import styles from './search_header.module.scss';
import { Navigation } from '../../navigation/Navigation';
import { HeaderContentLogo } from '../HeaderContentLogo';

type Props = UserContextType;

export const RawSearchHeader: FC<Props> = ({ loggedIn }) => {
  return (
    <header id="nav" className={classNames(styles.container)}>
      <HeaderContent>
        <div className={styles.subContainer}>
          <HeaderContentLogo loggedIn={loggedIn} source="nav" />
          <div className={styles.searchContainer}>
            <SearchBar />
          </div>
          <div className={styles.navContainer}>
            <Navigation />
          </div>
        </div>
      </HeaderContent>
    </header>
  );
};

export const SearchHeader = withUser(RawSearchHeader);
